import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatDate,
  formatDateTime,
  NoWrap,
  numberFormat,
} from "../../utils/helpers";
import { URL_TICKET_CATEGORIZATION } from "../../utils/urls";

export const useErrorLogs = () => {
  const tableColumns = () => [
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "name",
      header: "Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "category_code",
      header: "Category Code",
    },
    {
      id: "description",
      header: "Description",
      filter: {
        type: "text",
      },
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item?.created_at),
        name: item?.name,
        category_code: item?.category_code,
        description: <NoWrap>{item?.description}</NoWrap>,
        actions: (
          <FormActions
            actions={createViewEdit(
              `${URL_TICKET_CATEGORIZATION}`,
              item?.id,
              false,
            )}
          />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [
    {
      id: "account",
      header: "Account",
      filter: { type: "text" },
    },
  ];

  const tableTotals = (data: any) => {
    return {
      amount: numberFormat(data?.metadata?.total_amount),
    };
  };

  const viewData = (item: any) => {
    return {
      created_at: formatDateTime(item?.created_at),
      name: item?.name,
      category_code: item?.category_code,
      description: item?.description,
    };
  };

  // const activityFilter = "ledger_record";

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,

    externalFilters,
    // activityFilter,
  };
};
